/* eslint-disable react/no-danger */
import React, { useState, useEffect,useRef } from 'react';
import PropTypes from 'prop-types';
import Modal, { ModalSize } from '../../molecules/modal/modal';
import Broadcast from '../../../store/externalCalls/broadcast';
import Button, { ButtonType, ButtonTheme, ButtonSize } from '../../atoms/button/button';
import FormCheckbox from '../../molecules/formCheckbox/formCheckbox';

// import './LogComponent.scss';
import { IconSize, IconType } from '../../atoms/icon/icon';
import { initial, isString } from 'lodash';
import TimestampAgo from '../../atoms/timestamp/timestampAgo';
import swal from 'sweetalert';
import { httpDelete, httpGet, httpPost, httpPut } from '../../../store/externalCalls/httpCalls';
import FormPopup from '../../molecules/formPopup/formPopup';
import Table from '../../molecules/table/table';
import './PopupTable.scss';
import Toaste from '../../atoms/toast/toaste';

const PopupTable = (props) => {
  const {
   i,
   configFile,
   field,
   value,
   newButton,
   secondaryButtonText,
   disabledOnNew,
   onChangeAndRefresh

  } = props;
  const [popupForm,setPopupForm] =useState(null);
  const [popupShow,setPopupShow] =useState(null);
  const [configModalForm,setConfigModalForm] = useState(null);
  const [popupMode,setPopupMode] = useState(null);
  const [popupLabel,setPopupLabel] =useState(null);
  const [popupData,setPopupData] =useState(null);
  const [popupError,setPopupError] =useState(null);
  const [errors, setErrors] = useState({});
  const [valueTable,setValueTable] =useState(null);

  const handlerNewForm=(field)=>{
    setPopupMode("new");
    setConfigModalForm(configFile.contentFormNew);
    setPopupLabel(configFile.contentFormNew[0].title);
    setPopupShow(true);
  }
  const handlerSecondaryForm=(field)=>{
    setPopupMode("secondary");
    setConfigModalForm(configFile.contentFormSecondary);
    setPopupLabel(configFile.contentFormSecondary[0].title);
    setPopupShow(true);
  }
  const handlerNewPopup=(e,field,values)=>{
    let editId="";
    let location=window.location.pathname;
    let locationArr = location.split("/");
    editId="/"+locationArr[locationArr.length-1];
    let validationUrl=configFile.contentFormUrl +editId;
    httpPut(validationUrl, values).then((res)=>{
        //resolve({status:true,value:res.value});
        setPopupShow(false);
        setPopupError(null);
        setValueTable(res);
    }).catch(error=>{
        setPopupError(error);
    });
    //   }else{
    //     httpPost(validationUrl, params).then((res)=>{
    //       history.push("edit/"+res.id);
    //       resolve({status:true,value:res.value});
    //     }).catch(error=>{
    //       reject(error);
    //     });
    //   }
  }

  const handlerChangePopup=(e,field,values)=>{
    let editId="";
    let location=window.location.pathname;
    let locationArr = location.split("/");
    editId="/"+locationArr[locationArr.length-1];
    let validationUrl=configFile.contentFormUrl +editId;
    if(popupMode=="secondary"){
      validationUrl+="/"+configFile.secondaryParamUrl;
    }
    httpPut(validationUrl, values).then((res)=>{
        //resolve({status:true,value:res.value});
        setPopupShow(false);
        setPopupError(null);
        setValueTable(res);
    }).catch(error=>{
        setPopupError(error);
    });
  }
  const handlerClosePopup=()=>{
      setPopupMode(null);
      setPopupShow(false);
  }
  const handlerOnChange=()=>{
      console.log("onchange");
  }
  const handlerOnChangeRefresh=(data)=>{
    console.log("yes",data);
    onChangeAndRefresh(data);
  }
  const handlerOnTableCreate=()=>{
      console.log("ontablecreate");
  }
  const handlerOnTableEdit=(e,field)=>{
    //query by contentId =e.id
    let editId="";
    let location=window.location.pathname;
    let locationArr = location.split("/");
    editId="/"+locationArr[locationArr.length-1];
    let validationUrl=configFile.contentFormUrl +editId+"/"+e.id;
    httpGet(validationUrl).then((res)=>{
        //resolve({status:true,value:res.value});
        setPopupData(res);
    }).catch(error=>{
        setPopupError(error);
    });
    setConfigModalForm(configFile.contentFormEdit);
    setPopupLabel(configFile.contentFormEdit[0].title);
    setPopupMode("edit");
    setPopupShow(true);
}
  const handlerOnTableDelete=(e,field)=>{
    //query by contentId =e.id
    let editId="";
    let location=window.location.pathname;
    let locationArr = location.split("/");
    editId="/"+locationArr[locationArr.length-1];
    let validationUrl=configFile.contentFormUrl +editId+"/"+e.id;
    swal({
      title: 'Are you sure?',
      text: 'You are deleting an item and this action cannot be undone.',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        httpDelete(validationUrl).then((res)=>{
        setValueTable(res);
        }).catch(error=>{
            setPopupError(error);
        });
      }
    });
   
  }
  const onSearchTable=(e)=>{
    console.log("search",e);
    // onSearch(e);
  }
  const onChangeItemPosition=()=>{
      console.log("changeeitem");
  }
  const handlerOnInputRelationshipTableDelete=()=>{
      console.log("relationship");
  }
  const isNewPage=()=>{
    let newValue = window.location.pathname.split('/')[window.location.pathname.split('/').length-1];
    if(newValue=="new")
      return true;
    else
      return false;
  }

  useEffect(() => {
    // console.log("test");
    setValueTable(value);
  }, [value]);

  useEffect(() => {
    if(popupError!=null){
      const messages = popupError.errors;
      setErrors(messages);
      setTimeout(() => {
        setErrors({});
      }, 5000);
    }  
  }, [popupError]);
  return(
    <>
    { Object.keys(errors).length > 0
          && (
            <Toaste type="error" mode="toast" data={errors} />
          )}
      {disabledOnNew && isNewPage() && <div align="center">Only available when editing the form</div>}
        <FormPopup size={'xl'} id={i} mode={popupMode} nextId={i} title={popupLabel} 
            configFile={configModalForm} 
            field={configFile.attributeName}  
            value={popupData} 
            show={popupShow} params={''} 
            uniqueId={i} parentUID={i} 
            parentData={i}
            popupError={popupError}
            customSession={(value["customSession"]?value["customSession"]:null)}
            onNewPopup={handlerNewPopup} 
            onEditPopup={handlerChangePopup}
            onClosePopup={handlerClosePopup}/>
        {newButton && (!disabledOnNew || (disabledOnNew && !isNewPage())) && <Button
            id={`${configFile.attributeName}`}
            theme={ButtonTheme.PRIMARY}
            className={"btn btn-primary btn-sm "+configFile.attributeName+"--new"}
            onClick={handlerNewForm}
        >
            New
        </Button>}
        {secondaryButtonText && (!disabledOnNew || (disabledOnNew && !isNewPage())) && <Button
            id={`${configFile.attributeName}`}
            theme={ButtonTheme.SUCCESS}
            className={"btn btn-primary btn-sm "+configFile.attributeName+"--secondaryButton"+ " popupTable-button-margin-left"}
            onClick={handlerSecondaryForm}
        >
            {secondaryButtonText}
        </Button>}
        {valueTable && (!disabledOnNew || (disabledOnNew && !isNewPage())) && <Table
            id={`${configFile.attributeName}-${field.attributeName}`}
            key={field.attributeName + i}
            dataSet={valueTable[field.attributeName] === undefined ? [] : valueTable[field.attributeName]}
            columnSet={field.configFile.fields}
            label={field.label}
            canEdit={field.configFile.canEdit}
            canRemove={field.configFile.canRemove}
            onChange={(event) => handlerOnChange({ target: { value: event } }, field.attributeName)}
            onChangeAndRefresh={handlerOnChangeRefresh}
            canOpen={field.configFile.canOpen}
            canCreate={field.configFile.canCreate}
            onClickCreate={(event) => handlerOnTableCreate(event, field.attributeName)}
            onClickRemove={(event) => handlerOnTableDelete(event, field.attributeName)}
            onClickEdit={(event) => handlerOnTableEdit(event, field.attributeName)}
            onClickRemoveInputRelationship={(event) => handlerOnInputRelationshipTableDelete(event, field.attributeName)}
            emptyMessage={field.configFile.emptyMessage}
            isSelectable={field.configFile.isSelectable}
            isMultiSelectable={field.configFile.isMultiSelectable}
            canChangePosition={field.configFile.canChangePosition}
            sortingPositionIndex={field.configFile.sortingPositionIndex}
            onChangePosition={onChangeItemPosition}
            onSearch={onSearchTable}
        />}
    </>
  );

}


  export default PopupTable;
